import Axios from "axios";
import React from "react";
import { UserContextProvider } from "./context/UserContext";
import Router from "./Router";

Axios.defaults.withCredentials = true;

function App() {
  return (
    <UserContextProvider>
      <div>
        <Router />
      </div>
    </UserContextProvider>
  );
}

export default App;